import React, {useEffect} from 'react';
import config from '../config'
import * as Sentry from "@sentry/browser";

// require("antd/dist/antd.less");

import FlightCalculatorWidgetEmbedded from "./components/FlightCalculatorWidgetEmbedded";

Sentry.init({
  release: config.pipeline_id || "unknown",
  environment: config.deployment_env,
  dsn: config.sentry_dsn,
  ignoreErrors: [
    /^Non-Error promise rejection captured with value: Object Not Found Matching/
  ]
});

//PLACEHOLDER STYLE AND CONTENTS MUST BE KEPT IN SYNC (TEST ON SLOW CONNECTION) AS INDEX.HTML
const loadingPlaceholder = (
  <div style={{height: '100px', width: '100%', display: 'grid'}}>
    <div style={{margin: 'auto'}}>
      <pre style={{fontSize: '16px',lineHeight: 1.5,fontFamily: "monospace",marginTop: '40px'}}>Loading Carbon Calculator...</pre>
    </div>
  </div>
);
//PLACEHOLDER STYLE AND CONTENTS MUST BE KEPT IN SYNC (TEST ON SLOW CONNECTION) AS INDEX.HTML



import('react-dom').then(({render}) => render(
  <React.StrictMode>
    <React.Suspense fallback={loadingPlaceholder}>
      <FlightCalculatorWidgetEmbedded loadingPlaceholder={loadingPlaceholder}/>
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById("app")
));


